<template>
  <MainNavigation />
</template>

<script>
import MainNavigation from '../src/components/MainNavigation.vue'

export default {
  name: 'App',
  async created() {
  },
  components: {
    MainNavigation
  }
}
</script>

<style>

body{
  font-size: 18px !important;
  /* min-height: 100vh; */
  background-color: var(--slate-gray);
}
#app {
  overflow-y: hidden;
  height: auto;
  /* min-height: 100vh; */
}
.ag-theme-alpine-dark {
    --ag-background-color: var(--slate-gray) !important;
    --ag-foreground-color: #fff;
    --ag-border-color: #68686e;
    --ag-secondary-border-color: rgba(88, 86, 82, 0.5);
    --ag-header-background-color: var(--slate-gray) !important;
    --ag-odd-row-background-color: var(--secondary-slate);
    --ag-control-panel-background-color: var(--secondary-slate);
    --ag-subheader-background-color: #000;
    --ag-input-disabled-background-color: #282c2f;
    --ag-input-focus-box-shadow: 0 0 2px 0.5px rgba(255, 255, 255, 0.5),
      0 0 4px 3px var(--ag-input-focus-border-color);
    --ag-card-shadow: 0 1px 20px 1px black;
    --ag-disabled-foreground-color: rgba(255, 255, 255, 0.5);
    --ag-chip-background-color: rgba(255, 255, 255, 0.07);
    --ag-input-disabled-border-color: rgba(104, 104, 110, 0.3);
    --ag-input-disabled-background-color: rgba(104, 104, 110, 0.07);
    /* --ag-font-family: monospace !important; */
    --ag-font-weight: 500 !important;
    --ag-font-size: 16px !important;
}
.ag-header-cell-text {

  font-weight: 400 !important;
  font-size: 14px !important;
}
.severe {
  color: var(--severe-color);
}
.critical {
  color: var(--critical-color);
}
.high {
  color: var(--high-color);
}
.informational {
  color: var(--informational-color);
}
.cursor-pointer {
  cursor: pointer;
}
</style>
